import { createReducer } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  status: null,
  message: null,
  response: null,
  originalMessage: null,
  sector: null,
  timestamp: null,
  error: null
};

const smechatbotReducer = createReducer(initialState, {
  CHATBOT_REQ: (state) => {
    state.loading = true;
    state.error = null;
    state.status = null;
    state.message = null;
    state.response = null;
    state.originalMessage = null;
    state.sector = null;
    state.timestamp = null;
  },

  CHATBOT_FETCH_SUC: (state, action) => {
    const { response, originalMessage, sector, timestamp } = action.payload;
    
    state.loading = false;
    state.status = "success";
    state.response = response;
    state.originalMessage = originalMessage;
    state.sector = sector;
    state.timestamp = timestamp;
    state.error = null;
  },

  CHATBOT_ERROR: (state, action) => {
    state.loading = false;
    state.status = "error";
    state.error = action.payload?.error || "Unknown error occurred";
  }
});
export default smechatbotReducer;
